module.exports = __webpack_public_path__ + "img/inu.9cd845a4.png";